"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchResult;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _searchBreadcrumbs = _interopRequireDefault(require("./search-breadcrumbs"));
var _text = _interopRequireDefault(require("@ux/text"));
const Wrapper = /*#__PURE__*/(0, _react2.styled)(_text.default.div)({
  name: "Wrapper",
  class: "pl-w2ctb8z"
});
const Headline = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Headline",
  class: "pl-hj1qdub"
});
const SuggestionButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "SuggestionButton",
  class: "pl-s1x4fs0h"
});
function SearchResult({
  id,
  result,
  title,
  headline,
  description,
  url,
  resultsExternalPaths,
  breadcrumbs,
  value,
  step,
  search,
  highlight,
  style,
  isSelected,
  trackingCustomProperties = {},
  titleSize = 1
}) {
  if (typeof result === 'string') {
    title = result;
  }
  const trackingProps = _patternLibraryUtils.tracking.create(`${step}_${id}_${title}`, true, false, trackingCustomProperties);
  const externalPaths = resultsExternalPaths?.split(',')?.map(path => path.trim());
  const urlTarget = externalPaths?.some(path => url?.includes(path)) ? '_blank' : '_self';
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "result",
    selected: isSelected,
    style: style
  }, step === 'results' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Headline, (0, _extends2.default)({
    href: url,
    target: urlTarget
  }, trackingProps), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "title",
    size: titleSize
  }, title, " ", headline && /*#__PURE__*/_react.default.createElement(_text.default.span, {
    "data-cy": "r-headline"
  }, "| ", headline)), description && /*#__PURE__*/_react.default.createElement(_text.default.p, null, description)), breadcrumbs && /*#__PURE__*/_react.default.createElement(_searchBreadcrumbs.default, {
    breadcrumbs: breadcrumbs,
    resultsExternalPaths: externalPaths,
    searchTerm: value,
    resultTitle: title
  })) : /*#__PURE__*/_react.default.createElement(SuggestionButton, (0, _extends2.default)({
    className: "ux-button ux-button-inline",
    "data-step": step,
    onClick: () => search(title)
  }, trackingProps), step === 'suggestions' ? highlight(title, value) : title));
}
SearchResult.propTypes = {
  id: _propTypes.default.string,
  result: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  title: _propTypes.default.string,
  headline: _propTypes.default.string,
  description: _propTypes.default.string,
  url: _propTypes.default.string,
  breadcrumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  resultsExternalPaths: _propTypes.default.string,
  value: _propTypes.default.string,
  step: _propTypes.default.string,
  search: _propTypes.default.func,
  highlight: _propTypes.default.func,
  style: _propTypes.default.object,
  isSelected: _propTypes.default.bool,
  trackingCustomProperties: _propTypes.default.object,
  titleSize: _propTypes.default.number
};